import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('if_you_think_you_should__add_you_as_a_requester'),
};
